import { useMemo } from "react";

interface GenericLogoProps {
  color?: string;
  width?: number;
  height?: number;
}

const GenericLogo = ({
  color = "#0077CC",
  width = 101,
  height = 100,
}: GenericLogoProps) => {
  const svgContent = useMemo(
    () => (
      <svg
        width={width}
        height={height}
        viewBox="0 0 101 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2510_14296)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.3893 29.2132C60.278 26.4662 55.4445 25 50.5 25V0C60.389 0 70.056 2.93245 78.2785 8.42652C86.501 13.9206 92.9095 21.7295 96.694 30.8658C100.478 40.002 101.468 50.0555 99.5392 59.7545C97.61 69.4535 92.848 78.3628 85.8553 85.3553C78.8628 92.348 69.9535 97.11 60.2545 99.0392C50.5555 100.968 40.502 99.9783 31.3658 96.194C22.2295 92.4095 14.4206 86.001 8.92652 77.7785C3.43245 69.556 0.5 59.889 0.5 50H25.5C25.5 54.9445 26.9662 59.778 29.7132 63.8893C32.4602 68.0005 36.3648 71.2048 40.933 73.097C45.501 74.9893 50.5277 75.4843 55.3772 74.5195C60.2267 73.555 64.6813 71.174 68.1778 67.6778C71.674 64.1813 74.055 59.7267 75.0195 54.8772C75.9843 50.0277 75.4893 45.001 73.597 40.433C71.7048 35.8648 68.5005 31.9602 64.3893 29.2132Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.5 1.08281e-05C25.5 3.28306 24.8534 6.53396 23.597 9.56708C22.3406 12.6002 20.4991 15.3562 18.1777 17.6777C15.8562 19.9992 13.1002 21.8406 10.0671 23.097C7.03394 24.3534 3.78304 25 0.500001 25L0.5 50C7.06609 50 13.5679 48.7068 19.6342 46.194C25.7005 43.6813 31.2125 39.9983 35.8552 35.3553C40.4982 30.7125 44.1812 25.2005 46.694 19.1342C49.2067 13.0679 50.5 6.56608 50.5 0L25.5 1.08281e-05Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_2510_14296">
            <rect
              width="100"
              height="100"
              fill="white"
              transform="translate(0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    [color, width, height]
  );

  return svgContent;
};

export default GenericLogo;
